import React from 'react';
import { UtilityComponent } from './base';

export class CarouselArrow extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount(){

    }

    onClick(event){
       this.props.onClick();
    }
    
    render(){
        var cls='carousel-icon ' + this.props.cls;
        return(
            <div className={cls} onClick={this.onClick.bind(this)}>
              <i className="material-icons">
                {this.props.icon}
              </i>
            </div>
        );
    }
}

export class CarouselItem extends React.Component{
    constructor(props){
        super(props)
        this.videoIsPlaying=false;
    }

    onVisibilityChange(obj){
        var height=obj[0].target.clientHeight;
        if(height===0){
            this.videoIsPlaying=false;
            setTimeout(()=>{
                this.img.classList.remove('hidden');
            },1000);
        }
    }

    setElements(){
        this.img=this.item.querySelector('img');
        this.video=this.item.querySelector('video');
        this.video.addEventListener('ended',()=>{
            this.img.classList.remove('hidden');
            this.video.classList.remove('show');
            this.videoIsPlaying=false;
        });
        var options = {
          root: null,
          rootMargin: '0px',
          threshold:0
        }
        var observer = new IntersectionObserver(this.onVisibilityChange.bind(this), options);
        observer.observe(this.video);
    }

    handleVideo(){
        if(!this.img) this.setElements();
        if(!this.videoIsPlaying){
            this.img.classList.add('hidden');
            this.video.classList.add('show');
            this.videoIsPlaying=true;
            this.video.play();
        }else{
            this.videoIsPlaying=false;
            this.video.pause();
        }
    }

    onClick(event){
        if(this.props.link) location.href=this.props.link;
        else if(this.props.video) this.handleVideo();
        else if(this.props.target) window.open(target);
    }

    render(){
        var cls='carousel-item';
        if(this.props.link || this.props.target || this.props.video) cls+=' pointer';
        return(
            <div className={cls} onClick={this.onClick.bind(this)} ref={(ref) => this.item = ref}>
                {this.props.gradient &&
                   <div className="gradient-item-top"></div>
                }
                {this.props.children}
            </div>
        );
    }
}

export class CarouselBase extends UtilityComponent{
    constructor(props){
        super(props)
        this.index=0;
        this.interval=this.props.interval || 4000;
        this.intervalId=null;
    }

    componentDidMount(){
        this.initialize();
    }

    componentDidUpdate(){
        this.clearInterval();
        this.index=0;
        this.initialize();
    }

    initialize(){
       this.items = [].slice.call(this.innerContainer.querySelectorAll(".carousel-item"));
       this.videos=[].slice.call(this.innerContainer.querySelectorAll("video"));
       this.count=this.items.length;
       this.maxIndex=this.count-1;
       this.jqueryInterval(()=>{
           if(this.isTouch) this.listenForSwipe();
           if(this.props.auto && this.count > 1) this.startAutoSlides(); 
       });
    }

    jqueryInterval(callback){
        var jqueryCheck=setInterval(()=>{
            if($){
               clearInterval(jqueryCheck);
               callback();
            }
        },500);
    }

    startAutoSlides(){
        this.intervalId=setInterval(()=>{
            this.slideNext();
        },this.interval);
    }

    listenForSwipe(){
        $(this.innerContainer).on('swipeleft swiperight',(e)=>{
            if(e.type==='swipeleft') this.onSwipeLeft();
            else if(e.type==='swiperight') this.onSwipeRight();
        })
    }

    pauseAnyVideosOnSlide(){
        if(this.videos && this.videos.length){
            this.videos.forEach((video)=>{
                video.classList.remove('show');
                video.pause();
            });  
        }
    }

    clearInterval(){
        if(this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId=null;
        }
    }

    onPrevClick(){
       this.clearInterval();
       this.slidePrev();
    }

    onNextClick(){
       this.clearInterval(); 
       this.slideNext();
    }

    onSwipeLeft(){
       this.clearInterval(); 
       this.slidePrev(); 
    }

    onSwipeRight(){
       this.clearInterval(); 
       this.slideNext();  
    }

    slidePrev(){
       var prevIndex;
       var currentIndex=this.index;
       if(this.index>0) prevIndex=this.index - 1;
       else prevIndex=this.maxIndex;
       var currentSlide=this.items[currentIndex];
       var nextSlide=this.items[prevIndex];
       this.index=prevIndex;
       this.pauseAnyVideosOnSlide();
       this.slide(currentSlide,nextSlide);
       this.onSlide(prevIndex);
    }

    slideNext(){
       var nextIndex;
       var currentIndex=this.index;
       if(this.index<this.maxIndex) nextIndex=this.index + 1;
       else nextIndex=0;
       var currentSlide=this.items[currentIndex];
       var nextSlide=this.items[nextIndex];
       this.index=nextIndex;
       this.pauseAnyVideosOnSlide();
       this.slide(currentSlide,nextSlide);
       this.onSlide(nextIndex);
    }

    onSlide(index){

    }

}

export class FadeCarouselBase extends CarouselBase{
    constructor(props){
        super(props)
        this.fadeDuration=(this.props.fadeDuration) || 1000;
    }

    componentDidMount(){
        super.componentDidMount();
    }

    componentDidUpdate(){
        super.componentDidUpdate();
    }

    slide(currentSlide,nextSlide){
        currentSlide=$(currentSlide);
        currentSlide.css({
            position: 'absolute',
            display: 'block',
            float: 'none',
            'z-index': 1
        });
        nextSlide=$(nextSlide);
        nextSlide.css({
            position: 'relative',
            display: 'block',
            float: 'left',
            'z-index': 2
        });
        var duration=this.fadeDuration;
        this._transition(currentSlide, {
              opacity: 0,
              duration: duration-50
          });
        setTimeout(()=>{
            this._transition(nextSlide, {
                opacity: 1,
                duration: duration
            });
        },10);   
    }

    _transition(element, options, callback){
        $.transition=$.transition || $.transit;
        if (!(element instanceof jQuery)) element=$(element);
        options = options || {};
        if (options === {}) {
            options.duration = 300;
            options.preset = 'fadeIn';
        }
        if(options.preset==='none'){
            element.hide();
            return;
        }
        element.transition(options, function () {
            if (callback) {
                callback.call(element[ 0 ]);
            }
        });
    }

}

export class CarouselIndicator extends React.Component{
    constructor(props){
        super(props)
    }

    componentDidMount(){

    }

    onClick(event){
        this.props.onClick(this.props.index);
    }

    render(){
        var css='material-icons';
        if(this.props.active) css+=' active';
        return(
            <i className={css} index={this.props.index} onClick={this.onClick.bind(this)}>fiber_manual_record</i>
        );
    }
}

export class CarouselIndicators extends React.Component{
    constructor(props){
        super(props)
        var activeIndex=0;
        if(this.props.activeIndex) activeIndex=this.props.activeIndex;
        this.state={activeIndex:activeIndex};
    }

    componentDidMount(){

    }

    update(index){
        this.state.activeIndex=index;
        this.setState(this.state);
    }

    render(){
        var css='carousel-indicators-container';
        if(this.props.cssProp) css+=' ' + this.props.cssProp;
        var activeIndex=this.state.activeIndex;
        var count=this.props.count;
        var arr=[...Array(count).keys()]
        var nodes = arr.map((index)=> {
            var active=false;
            if(index==activeIndex) active=true;
            return(
                    <CarouselIndicator key={index} index={index} active={active} onClick={this.props.onClick} />
                  );
        });
        return(
            <div className={css}>
                {nodes}
            </div>
        );
    }
}

export class FadeCarousel extends FadeCarouselBase{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        super.componentDidMount();
    }

    componentDidUpdate(){
        super.componentDidUpdate();
    }

    render(){
        return(
             <div className="carousel-container" onClick={this.clearInterval.bind(this)}>
                <CarouselArrow cls="prev" icon="arrow_back_ios" onClick={this.onPrevClick.bind(this)} />
                <CarouselArrow cls="next" icon="arrow_forward_ios" onClick={this.onNextClick.bind(this)} />
                <div className="carousel-inner-container" ref={(ref) => this.innerContainer = ref}>
                   {this.props.children}
                </div>
             </div>
        );
    }
}

export class BasicCarousel extends FadeCarouselBase{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        super.componentDidMount();
    }

    componentDidUpdate(){
        super.componentDidUpdate();
    }

    slideByIndex(index){
       this.clearInterval(); 
       var currentIndex=this.index;
       var currentSlide=this.items[currentIndex];
       var nextSlide=this.items[index];
       this.index=index;
       this.pauseAnyVideosOnSlide();
       this.slide(currentSlide,nextSlide);
       this.onSlide(index);
    }

    onSlide(index){
        this.props.onSlide(index);
    }

    render(){
        return(
             <div className="carousel-container" onClick={this.clearInterval.bind(this)}>
                <div className="carousel-inner-container" ref={(ref) => this.innerContainer = ref}>
                   {this.props.children}
                </div>
             </div>
        );
    }
}

export default{
    CarouselArrow,
    CarouselItem,
    CarouselBase,
    FadeCarouselBase,
    CarouselIndicator,
    CarouselIndicators,
    FadeCarousel,
    BasicCarousel
}